import { Routes } from '@angular/router';
import { NotFoundComponent } from './not-found/not-found.component';
import { subdomainMatchGuard } from './common-resource/_guard/subdomain-match.guard';
import { ensureEventSlugGuard } from './common-resource/_guard/ensure-event-slug.guard';
import { customDomainEventSlugMatchGuard, verifyEventSlugGuard } from './common-resource/_guard/custom-domain-event-slug.guard';


export const routes: Routes = [
    {
        path: 'payment/:cartId',
        loadComponent: () => import('./theme/payment/payment.component').then(m => m.PaymentComponent),
    },
    // tickets.fnkone.com
    {
        path: '',
        canMatch: [subdomainMatchGuard],//for tickets.fnkone.com
        loadChildren: () => import('./theme/event.routes').then(m => m.eventRoutes),
        loadComponent: ()=> import('../app/common-resource/shared-layout/shared-layout.component').then(m=>m.SharedLayoutComponent),
    },
    {
        path: '',
        canMatch: [customDomainEventSlugMatchGuard],//for other than tickets.fnkone.com/ like  tickets.nikhil.com/event-slug/event
        canActivate: [verifyEventSlugGuard],
        loadChildren: () => import('./theme/event.routes').then(m => m.eventRoutes),
        loadComponent: ()=> import('../app/common-resource/shared-layout/shared-layout.component').then(m=>m.SharedLayoutComponent),
    },
    {
        path: '',
        canActivate: [ensureEventSlugGuard],//for other than event-slug.fnkone.com/ or tickets.nikhil.com/
        loadChildren: () => import('./theme/customDomain.routes').then(m => m.customDomainRoutes),
        loadComponent: ()=> import('../app/common-resource/shared-layout/shared-layout.component').then(m=>m.SharedLayoutComponent),
    },
    {
        path:'**',
        component:NotFoundComponent
    }

]
